// @ vendors
import React from 'react';

const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const classNames = require('classnames');
const formActions = require('react-redux-form').actions;
const cryptoJS = require('crypto-js');
// @ actions
const cmsActions = require('actions/cmsActions');
const productsActions = require('actions/productsActions');
// @ components
const AppliedPromoCode = require('components/promotionalCode/appliedPromoCode');
const CreditCardOffer = require('components/creditCardOffer/creditCardOffer');
const CreditCardOfferInfoModal = require('components/creditCardOfferInfoModal/creditCardOfferInfoModal');
const ProductInformation = require('components/commons/productInformation/productInformation');
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const CustomTooltip = require('components/tooltip/customTooltip');
// @ utilities
import { FormattedText, formatText, getLanguage } from 'core/i18n';
// @ constants
const arrowIcon = require('assets/icons/icon-arrow.svg');
const { REGISTER_TEXT, REGISTER_TOOLTIP } = require('constants/cms');
import tooltipIcon from 'assets/icons/icon-tooltip.svg';
import { OPENCREDIT } from 'constants/featureFlagging';
// @ utilities
const UtagHelper = require('utilities/utagHelper');
const { recordEvent, recordPage, PAGE_PRODUCT } = require('utilities/uTagging');
const { PATH_JOINHOLDER_ACCESS_NO_CLIENT } = require('constants/uTagConstants/paths');
// @ HOCS
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class Information extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            animateClassName: '',
            showCreditCardInfoModal: false,
            showPromoCode: false,
        };

        this.handleCreditCardInfoModalVisibility = this.handleCreditCardInfoModalVisibility.bind(this);
        this.handleCreditCardOfferingChange = this.handleCreditCardOfferingChange.bind(this);
        this.onHandleStart = this.onHandleStart.bind(this);
        this.buildPromoCode = this.buildPromoCode.bind(this);
    }

    UNSAFE_componentWillMount() {
        setTimeout(() => {
            this.setState({
                animateClassName: 'animation-fade--show',
            });
        }, 1000);

        const { promotionalCode } = this.props;
        const promoCode = promotionalCode.get('promotionalCode');
        if (promoCode.size > 0) {
            this.setState({
                showPromoCode: true,
            });
        }
    }

    componentDidMount() {
        const { cmsActions, userProfile, products } = this.props;
        const invite = userProfile.jointHolderData.invite;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromInvite(invite, 'no cliente');

        cmsActions.getCMS(REGISTER_TEXT, REGISTER_TOOLTIP);
        recordPage(
            PATH_JOINHOLDER_ACCESS_NO_CLIENT,
            '',
            '',
            userProfile.product,
            products.get('productsDescription'),
            invite.promoCode,
            JointHolderInfo,
            '',
            '',
            userProfile.investmentType,
            {
                identificadorOnboarding: userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '',
            }
        );
    }

    handleCreditCardInfoModalVisibility() {
        this.setState(prevState => ({
            showCreditCardInfoModal: !prevState.showCreditCardInfoModal,
        }));
    }

    handleCreditCardOfferingChange(checked) {
        const { promotionalCode, productsActions } = this.props;
        const codeId = promotionalCode && promotionalCode.getIn(['promotionalCode', 'code']);
        const language = getLanguage();

        productsActions.getCreditCardOffer(checked, codeId, language);
    }

    handleSuccessModal = () => {
        this.handleCreditCardOfferingChange(true);
        this.props.formActions.change('userProfile.creditCardOffer_accepted', true);
        this.handleCreditCardInfoModalVisibility();
    };

    onHandleStart() {
        const { formActions, userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        this.setState({
            animateClassName: 'animation-fade--hide',
        });

        recordEvent(
            PATH_JOINHOLDER_ACCESS_NO_CLIENT,
            PAGE_PRODUCT,
            'inicio interviniente no cliente',
            'comenzar proceso de alta',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );

        setTimeout(() => {
            formActions.change('userProfile.jointHolderForm', true);
        }, 500);
    }

    getjointHolderType() {
        const { userProfile } = this.props;
        const { jointHolderData } = userProfile;
        let holderType;

        switch (jointHolderData.invite.jointHolderType) {
            case 'cotitular':
                holderType = formatText('jointHolderAccountType-jointHolder1');
                break;
            case 'autorizado':
                holderType = formatText('jointHolderAccountType-authorized');
                break;
            default:
                break;
        }

        return holderType;
    }

    buildPromoCode() {
        const { promotionalCode } = this.props;

        if (this.state.showPromoCode) {
            const promoCode = promotionalCode.get('promotionalCode');

            return (
                <AppliedPromoCode
                    title={promoCode.get('title')}
                    description={promoCode.get('details')}
                    img={promoCode.get('img')}
                />
            );
        }
    }

    buildBrokerHeader(accountText) {
        const accountTextTitle = accountText.slice(0, accountText.indexOf('+') - 1);
        const accountTextSubTilte = accountText.slice(accountText.indexOf('+'), accountText.lenght);
        const brokerHeader = (
            <span>
                <span style={{ fontSize: 16 }}>
                    <b>{accountTextTitle}</b>
                </span>
                <br />
                <span style={{ fontSize: 14 }}>{accountTextSubTilte}</span>
            </span>
        );

        return brokerHeader;
    }

    buildCreditCardOffering() {
        const { cms, userProfile } = this.props;
        let text = formatText('CMS-registerTCText');
        let tooltip = formatText('CMS-registroTCTooltip');
        let format,
            creditCardOffer = null;
        if (cms.getIn(['cmsRegister', 'text']) && cms.getIn(['cmsRegister', 'tooltip'])) {
            format = cms.getIn(['cmsRegister', 'tooltip']).replace('<a', '<a id=precontractual ');
            text = (
                <HTMLSafeInjector inline={true} message={cms.getIn(['cmsRegister', 'text']).replace(/p>/g, 'span>')} />
            );
            tooltip = <HTMLSafeInjector message={format} />;
        }
        const tooltipTarget = (
            <div className={'form__info-tooltip'}>
                <img className={'form__info-tooltip__img'} src={tooltipIcon} />
            </div>
        );
        const label = (
            <span>
                <FormattedText value="initial-creditCardOfferLabel" />
                <a
                    className="credit-card-offer__label-link"
                    href="#"
                    onClick={event => {
                        event.preventDefault();
                        this.handleCreditCardInfoModalVisibility();
                    }}
                >
                    <FormattedText value="creditCardOffer-infoModalLinkIconLabel" />
                    <img className="credit-card-offer__label-icon" src={arrowIcon} alt="" />
                </a>
            </span>
        );
        const subLabel = (
            <span className="credit-card-offer__sublabel">
                {text}
                <CustomTooltip
                    target={tooltipTarget}
                    content={<div className="credit-card-tooltip__popup">{tooltip}</div>}
                    type={'explanatory'}
                />
            </span>
        );

        creditCardOffer = (
            <CreditCardOffer
                label={label}
                onChange={this.handleCreditCardOfferingChange}
                remarkable={false}
                subLabel={subLabel}
                {...this.props}
            />
        );

        return (
            <div className="joint-holder-information__credit-card-container">
                {creditCardOffer}
                <CreditCardOfferInfoModal
                    show={this.state.showCreditCardInfoModal}
                    onClose={event => {
                        event.preventDefault();
                        this.handleCreditCardInfoModalVisibility();
                    }}
                    onSuccess={this.handleSuccessModal}
                    disabled={userProfile.creditCardOffer_accepted}
                />
            </div>
        );
    }

    render() {
        const { userProfile, products, flags } = this.props;
        const { jointHolderData } = userProfile;
        const className = classNames('joint-holder-information animation-fade', this.state.animateClassName);
        const buildPromoCode = this.buildPromoCode();
        const cardOffer = flags.get(OPENCREDIT) ? this.buildCreditCardOffering() : null;
        const debitCardKey = formatText('clientJointHolder-indexOfDebitCard');
        const isJointHolder = jointHolderData && jointHolderData.invite.jointHolderType === 'cotitular';

        let jointHolderAccountType = products.get('productsDescription');
        let jointHolderAccountTypeInfo = null;
        const jointHolderType = this.getjointHolderType();
        let jointHolderText = null;
        if (jointHolderData.invite.openDebitCard) {
            if (jointHolderAccountType && jointHolderData.invite.jointHolderType === 'cotitular') {
                const accountTypes = jointHolderAccountType.split(' + ');
                const debitCardIndex = accountTypes.indexOf(debitCardKey);

                accountTypes[debitCardIndex] = `${accountTypes[debitCardIndex]} *`;
                jointHolderAccountType = accountTypes.join(' + ');

                jointHolderAccountTypeInfo = (
                    <p className="product-information__account-type-info">
                        <FormattedText value="clientJointHolder-accountTypeInfo" />
                    </p>
                );

                if (jointHolderData.invite.promoCode === 'OPENCREDIT') {
                    jointHolderAccountType += '*';
                    jointHolderAccountTypeInfo = (
                        <p className="product-information__account-type-info-2">
                            *<FormattedText value="clientJointHolder-accountTypeInfo" />
                        </p>
                    );
                }
            }
        }
        let jointHolderAccountSubTitle = formatText('initial-jointHolderInformationText', [
            jointHolderData.accountOwner.accountOwnerName,
        ]);
        if (
            jointHolderData.invite.jointHolderType === 'cotitular' &&
            jointHolderData.invite.promoCode === 'OPENCREDIT'
        ) {
            jointHolderAccountSubTitle += '*';
            jointHolderText = (
                <div className="joint-holder-information__container--aclaration">
                    <FormattedText value="clientJointHolder-openCreditText" />
                </div>
            );
        }

        if (userProfile.valuesAccount) {
            jointHolderAccountType = this.buildBrokerHeader(jointHolderAccountType);
        }

        const information = (
            <div id="joint-holder-information" className={className}>
                <div className="joint-holder-information__container">
                    <h2 className="product-description-title">
                        <FormattedText
                            value="initial-jointHolderInformationTitle"
                            injectedStrings={[jointHolderData.invite.name]}
                        />
                    </h2>
                    <span className="dash" />
                    <p className="product-description-name">{jointHolderAccountSubTitle}</p>
                    <ProductInformation
                        jointHolderType={jointHolderType}
                        jointHolderAccountType={jointHolderAccountType}
                        noPadding={true}
                    />
                    {jointHolderText}
                    {jointHolderAccountTypeInfo}
                </div>
                {buildPromoCode}
                {isJointHolder && cardOffer}
                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueType="submit"
                            buttonPrevHidden={true}
                            buttonCancelHidden={true}
                            buttonContinueClass={'form__button form__button-secondary'}
                            buttonContinueText={<FormattedText value="button-start" />}
                            buttonContinueAction={this.onHandleStart}
                        />
                    </div>
                </div>
            </div>
        );

        return information;
    }
}

module.exports.constructor = Information;
module.exports.Information = connect(
    state => ({
        cms: state.cms,
        userProfile: state.userProfile,
        promotionalCode: state.promotionalCode,
        products: state.products,
    }),
    dispatch => ({
        cmsActions: bindActionCreators(cmsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        productsActions: bindActionCreators(productsActions, dispatch),
    })
)(withFeatureToggling(Information));
